import toast from "react-hot-toast";
import useApi from "../useApi";
import { IPatient } from "./index.type";

interface IUpdateCallStatusReq {
  status: "none" | "missing_documentation" | "unanswered_call";
}

interface IUpdateCallStatusRes {
  status: string;
  message: string;
  data?: IPatient;
}

const useUpdateCallStatus = () => {
  const { loading, makeApiCall } = useApi({
    url: "",
    method: "PATCH",
  });

  const updateCallStatus = async (
    patientId: string,
    data: IUpdateCallStatusReq,
  ): Promise<IUpdateCallStatusRes | undefined> => {
    const { response, error } = await makeApiCall<
      IUpdateCallStatusReq,
      IUpdateCallStatusRes
    >(
      data,
      `/rtm/billing-cycle/call-status?patientId=${patientId}`,
    );
    if (response?.status === "success") {
      toast.success(response.message);
      return response;
    }

    if (error) {
      toast.error(error.msg);
    }
  };

  return {
    updateCallStatus,
    loading,
  };
};

export default useUpdateCallStatus;
